import {Directive, DoCheck, Input, OnChanges, OnInit, TemplateRef, ViewContainerRef} from '@angular/core';
import {ProjectService} from "../services/project.service";

@Directive({
  selector: '[editable]',
  standalone: false
})
export class EditableDirective implements DoCheck{

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private projectService: ProjectService) {
  }

  ngDoCheck() {
    if (!this.projectService.activeProject?.editable){
      this.viewContainer.clear();
    } else if (this.viewContainer.length == 0) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
